import store from '@/store'
import Event from '@/libraries/eventbus'

// Listen for user updates
store.watch(() => store.getters['auth/user'], (new_value, old_value) => {
    if(!new_value || !old_value || new_value.team_id !== old_value.team_id) {
        Event.dispatch('team.changed')
    }
})